import React, {PureComponent} from 'react'
import injectSheet from 'react-jss'
import ImageWithQuote from './ImageWithQuote'

class ImageWithQuoteContainer extends PureComponent {

    render() {
        const {item} = this.props;

        return (
            <section>
                <ImageWithQuote item={item} />
            </section>
        )
    }
}

export default injectSheet({})(ImageWithQuoteContainer)





// WEBPACK FOOTER //
// ./src/components/Article/ImageWithQuoteContainer.js